import type { PrimeVuePTOptions } from 'primevue/config';

export default {
  root: {
    class: 'rounded-[16px] overflow-hidden',
  },
} satisfies PrimeVuePTOptions['dialog'];
